import * as React from "react";
import { Session, Sku, SiteSettings } from "../types";
import SummaryReceipt from "../common/SummaryReceipt";
import { SkuCategory } from "../types-enums";
import t from "../i18n";
import MaskedInput from "react-text-mask";
import { CatalogService } from "../services/catalog-service";

declare type SummaryProps = {
    session: Session,
    sku: Sku | undefined;
    siteSettings: SiteSettings
    converSalesTaxChanged: (value: boolean) => void;
    applyCouponCode: (value: string) => void;
    applyRewardPoints: (value: string) => void;
    smsChanged: (sms: string) => void;
}
declare type SummaryState = {
    loading: boolean;
    sms: string;
    couponCode: string;
    rewardPoints: string;
    showCouponCode: boolean;
}
export default class Summary extends React.Component<SummaryProps, SummaryState> {
    constructor(props: SummaryProps) {
        super(props);
        let showCouponCode: boolean = false;
        if (CatalogService.isSiteRedemptionPIN()) {
            showCouponCode = true;
        }
        this.state = {
            loading: false, sms: props.session.sms,
            couponCode: props.session.promoCode,
            rewardPoints: props.session.rewardPointsUsed ? `${props.session.rewardPointsUsed}` : "",
            showCouponCode: showCouponCode
        };
    }
    smsChanged = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        if (this.props.smsChanged) this.props.smsChanged(e.target.value);
    }
    getSmsText = () => {
        return this.state.sms;
    }
    renderUpsale() {
        const isData = this.props.session.skuCategory === SkuCategory.Data;
        const allowCoverSalesTax = this.props.sku ? this.props.sku.allowCoverSalesTax : false;
        const showUpsale = !!this.props.session.salesTax && !isData && allowCoverSalesTax;
        if (showUpsale === false) return null;
        return (
            <div className="d-flex align-items-center justify-content-end mb-3" style={{ paddingRight: 3 }}>
                <label className="font-weight-600 blue-text">
                    {t.topup("cover_sales_tax_message", {
                        currencyCode: this.props.session.sourceCurrencyCode,
                        faceValue: this.props.session.faceValue.toFixed(2),
                    })}
                </label>
                <input type="checkbox" className="ml-3" style={{ transform: "scale(1.5)" }}
                    checked={this.props.session.coverSalesTax}
                    onChange={e => this.props.converSalesTaxChanged(e.target.checked)}
                />
            </div>
        );
    }
    renderSMS() {
        if (!this.props.siteSettings.showSMS) return null;
        const smsFeeText = this.props.siteSettings.smsCharge ?
            `(${t.receipt("sms_fee", { fee: this.props.siteSettings.smsCharge * 100 })})` : '';
        return (
            <div className="form-group">
                <h5>{`${t.receipt("send_sms")} ${smsFeeText}`}</h5>
                <textarea className="form-control" maxLength={159}
                    value={this.props.session.sms || ""}
                    onChange={this.smsChanged} />
            </div>
        );
    }
    renderPromoCode() {
        if (!this.props.siteSettings.allowPromoCode) return null;
        if (this.props.session.rewardPointsUsed > 0) return null;
        {/* TODO: How to promo code label with Cashwave PIN in Site Settings*/ }
        let redemptionLabel = t.receipt("promo_code_label");
        let redemptionAppliedLabel = t.receipt("promo_code_applied");
        if (CatalogService.isSiteRedemptionPIN()) {
            redemptionLabel = t.receipt("pin_code_label");
            redemptionAppliedLabel=t.receipt("pin_code_applied");
        }
        if (this.props.session.promoCode && this.props.session.promoCodeDiscount) {
            return <div className="form-group">{redemptionAppliedLabel}</div>
        } else if (!this.state.showCouponCode) {
            return <div className="form-group text-right i-have-promocode">
                <a href="javascript:void(0)" onClick={e => this.setState({ showCouponCode: true })}>
                    {t.receipt("i_have_coupon")}
                </a>
            </div>
        } else {
            const couponCode = this.state.couponCode ? this.state.couponCode.trim() : "";
            const enableButton = !!couponCode;
            return (
                <React.Fragment>
                    <div className="form-group">
                        <h5>{redemptionLabel}</h5>
                        <div className="row">
                            <div className="col-6 col-sm-4">
                                <input type="text" className="form-control" maxLength={20}
                                    value={this.state.couponCode || ""}
                                    onChange={e => this.setState({ couponCode: e.target.value })} />
                            </div>
                            <div className="col-4 col-sm-4">
                                <button disabled={!enableButton} className="btn btn-primary apply-promo"
                                    onClick={e => this.props.applyCouponCode(this.state.couponCode)}>
                                    {t.topup("coupon_apply_label")}
                                </button>
                            </div>
                        </div>
                    </div>
                </React.Fragment>
            )
        }
    }
    renderStorePin() {
        if (!this.props.siteSettings.allowPromoCode) return null;
        if(CatalogService.isSiteVodafoneFiji()){
            return (
                <React.Fragment>
                    <div className="form-group">
                    {this.props.session.promoCode && this.props.session.promoCodeDiscount && 
                        <div className="form-group">{t.topup("pin_applied")}</div>        
                    }                        
                        <h5>{t.topup("enter_pin")}</h5>
                        <div className="row">
                            <div className="col-6 col-sm-4">
                                <input type="text" className="form-control" maxLength={20}
                                    value={this.state.couponCode || ""}
                                    onChange={e => this.setState({ couponCode: e.target.value })} />
                            </div>
                            <div className="col-4 col-sm-4">
                                <button className="btn btn-primary apply-promo"
                                    onClick={e => this.props.applyCouponCode(this.state.couponCode)}>
                                    {t.topup("coupon_apply_label")}
                                </button>&nbsp;
                                <button className="btn btn-primary apply-promo"
                                    onClick={e => {this.props.applyCouponCode("")}}>
                                    {t.topup("coupon_remove_label")}
                                </button>
                            </div>
                        </div>
                    </div>
                </React.Fragment>
            )            
        }
        if (this.props.session.promoCode && this.props.session.promoCodeDiscount) {
            return <div className="form-group">{t.topup("reward_code_applied")}</div>
        }
        else {
            const couponCode = this.state.couponCode ? this.state.couponCode.trim() : "";
            const enableButton = !!couponCode;
            return (
                <React.Fragment>
                    <div className="form-group">
                        <h5>{t.topup("enter_reward_code")}</h5>
                        <div className="row">
                            <div className="col-6 col-sm-4">
                                <input type="text" className="form-control" maxLength={20}
                                    value={this.state.couponCode || ""}
                                    onChange={e => this.setState({ couponCode: e.target.value })} />
                            </div>
                            <div className="col-4 col-sm-4">
                                <button disabled={!enableButton} className="btn btn-primary apply-promo"
                                    onClick={e => this.props.applyCouponCode(this.state.couponCode)}>
                                    {t.topup("coupon_apply_label")}
                                </button>
                            </div>
                        </div>
                    </div>
                </React.Fragment>
            )
        }
    }
    renderRewardPoints() {
        const { session } = this.props;
        const balance = session.rewardPointsBalance + session.rewardPointsUsed;
        if (!this.props.siteSettings.allowRewardPoints ||
            (balance < this.props.siteSettings.minRewardPoint) ||
            !!session.promoCode) {
            return null;
        }
        if (session.rewardPointsUsed > 0) {
            let message;
            if (session.netCharge === 0) {
                message = t.validations("reward_points_applied_full_amount", {
                    rewardPointsUsed: session.rewardPointsUsed
                });
            } else {
                message = t.validations("reward_points_applied", {
                    rewardPointsUsed: session.rewardPointsUsed,
                    netCharge: session.netCharge,
                    currency: session.sourceCurrencyCode
                });
            }
            return <div className="form-group" style={{ borderTop: "1px solid #ddd", paddingTop: 5 }}>
                <div>
                    <h5>{t.topup("reward_points_label")}</h5>
                    <div className="block">{message}</div>
                </div>
            </div>;
        } else {
            const rewardPoints = this.state.rewardPoints ? this.state.rewardPoints.trim() : '';
            const enableButton = !!rewardPoints;
            const mask = [/[1-9]/, /[\d\.]/, /[\d\.]/, /\d/, /\d/];
            const cc = this.props.session.sourceCurrencyCode;
            return <div className="form-group" style={{ borderTop: "1px solid #ddd", paddingTop: 5 }}>
                <h5>{t.topup("reward_points_label")}</h5>
                <div className="row">
                    <div className="col-12">
                        <div style={{ paddingTop: 5, paddingBottom: 5 }}>
                            {t.topup("reward_points_message", {
                                reward: session.rewardPointsBalance,
                                discount: session.rewardPointsBalance / 100,
                                currency: session.sourceCurrencyCode,
                                discountTopup: session.maxDiscountValue
                            })}
                        </div>
                    </div>
                    <div className="col-6 col-sm-4">
                        <div className="input-group">
                            <div className="input-group-prepend">
                                <span className="input-group-text" id="basic-addon1">{cc === "USD" ? "$" : cc}</span>
                            </div>
                            <MaskedInput mask={mask} guide={false}
                                pipe={value => value.substr(1, 2) === ".." ? value.substr(0, 2) : value}
                                className="form-control"
                                onChange={e => this.setState({ rewardPoints: e.target.value })}
                                value={this.state.rewardPoints || ""} />
                        </div>
                    </div>
                    <div className="col-4 col-sm-4">
                        <button disabled={!enableButton} className="btn btn-primary apply-points"
                            onClick={() => this.props.applyRewardPoints(this.state.rewardPoints)}>
                            {t.topup("coupon_apply_label")}
                        </button>
                    </div>
                </div>
            </div>
        };
    }
    render() {
        return (
            <React.Fragment>
                {this.renderSummary()}
                {this.renderStorePinSummary()}
            </React.Fragment>
        );
    }
    renderSummary() {
        if (CatalogService.isSiteRedemptionPIN()) return undefined;
        const { session } = this.props;
        return (
            <React.Fragment>
                {this.renderUpsale()}
                <div className="form-group">
                    <SummaryReceipt session={session} />
                </div>
                {this.renderSMS()}
                {this.renderPromoCode()}
                {this.renderRewardPoints()}
            </React.Fragment>
        );
    }

    renderStorePinSummary() {
        // used for Cashwave
        if (!CatalogService.isSiteRedemptionPIN()) return undefined;
        const { session } = this.props;
        return (
            <React.Fragment>
                {this.renderStorePin()}
                <div className="form-group">
                    <SummaryReceipt session={session} />
                </div>
            </React.Fragment>
        );
    }
    validate() {
        if (!CatalogService.isSiteRedemptionPIN()) return undefined;
        if (CatalogService.isSiteVodafoneFiji()) return undefined;
        if (this.props.session.netCharge === 0 && (this.props.session.promoCodeDiscount || 0 > 0)){
            return undefined;
        }
        else {
            return "You must enter pin code and click 'Apply' to complete transaction.";
        }
    }
}
